import { createContext, useContext, useState, useCallback, type ReactNode } from 'react'
import EducationalDrawer from './EducationalDrawer'

interface GlossaryContextValue {
  open: (termId: string) => void
  close: () => void
}

const GlossaryContext = createContext<GlossaryContextValue>({
  open: () => {},
  close: () => {},
})

export function GlossaryProvider({ children }: { children: ReactNode }) {
  const [termId, setTermId] = useState<string | null>(null)

  const open = useCallback((id: string) => setTermId(id), [])
  const close = useCallback(() => setTermId(null), [])
  const navigate = useCallback((id: string) => setTermId(id), [])

  return (
    <GlossaryContext.Provider value={{ open, close }}>
      {children}
      <EducationalDrawer termId={termId} onClose={close} onNavigate={navigate} />
    </GlossaryContext.Provider>
  )
}

export function useGlossary() {
  return useContext(GlossaryContext)
}
